import React from 'react';
export function TestimonialGrid() {
  const testimonials = [{
    avatar: 'https://randomuser.me/api/portraits/women/44.jpg',
    name: 'María G.',
    time: '19:42',
    text: '¡No me lo creo! Lo acabo de probar y no ha habido gritos. Ha sido mágico 😭'
  }, {
    avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
    name: 'Javier R.',
    time: '20:15',
    text: 'Se lo pasé a mi mujer porque no podíamos más. El ambiente en casa ha cambiado al 100%. Recomendado para cualquier padre.'
  }, {
    avatar: 'https://randomuser.me/api/portraits/women/68.jpg',
    name: 'Laura P.',
    time: '14:30',
    text: 'Mi hijo apagó él mismo el móvil ayer. Vale cada céntimo.'
  }];
  return <section className="py-12 px-4 bg-white" data-id="element-119">
      <div className="max-w-3xl mx-auto" data-id="element-120">
        <div className="flex flex-col gap-6" data-id="element-121">
          {testimonials.map((t, index) => <div key={index} className="flex flex-col gap-2" data-id="element-122">
              {/* WhatsApp style bubble */}
              <div className="bg-[#E1FFC7] rounded-2xl rounded-tl-none p-4 shadow-sm relative border border-[#d0f4b3] max-w-[90%] self-start" data-id="element-123">
                {/* Bubble tail */}
                <div className="absolute top-0 -left-[10px] w-0 h-0 border-t-[12px] border-t-[#E1FFC7] border-l-[12px] border-l-transparent" data-id="element-124"></div>

                <div className="flex items-center gap-3 mb-2" data-id="element-125">
                  <img src={t.avatar} alt={t.name} className="w-8 h-8 rounded-full object-cover shadow-sm border border-white" data-id="element-126" />
                  <p className="font-bold text-gray-800 text-sm" data-id="element-127">{t.name}</p>
                </div>

                <p className="text-gray-800 text-[15px] leading-relaxed mb-1" data-id="element-128">
                  {t.text}
                </p>

                <div className="text-right text-[11px] text-gray-500 flex justify-end items-center gap-1" data-id="element-129">
                  {t.time}
                  <svg viewBox="0 0 16 15" width="16" height="15" className="text-[#53bdeb] fill-current" data-id="element-130">
                    <path d="M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z" data-id="element-131"></path>
                  </svg>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}